<template>
  <div>
    <Title :pages="[{ icon: 'location-dot', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-combobox
                    density="comfortable"
                    v-model="filters.almacen"
                    item-title="label"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                    :loading="loading_almacenes"
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    density="comfortable"
                    v-model="filters.zona"
                    item-title="label"
                    item-value="id"
                    :items="zonas"
                    label="Zona"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                    :loading="loading_zonas"
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    density="comfortable"
                    v-model="filters.tipo_ubicacion"
                    item-title="label"
                    item-value="id"
                    :items="tipos_ubicaciones"
                    label="Tipo de Ubicacion"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                    :loading="loading_tipos_ubicaciones"
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    density="comfortable"
                    v-model="filters.status"
                    item-title="name"
                    item-value="id"
                    :items="states"
                    label="Estado"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-text-field v-model="filters.code" density="comfortable" label="Codigo" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.rack" density="comfortable" label="Rack" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.col" density="comfortable" label="Columna" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.level" density="comfortable" label="Nivel" :disabled="disabled"></v-text-field>
                </div>

                <div class="col-md-12 mt-2 mb-2" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <div class="mb-4 mt-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ props }">
              <v-icon
                :color="selected.length == 0 ? 'grey' : 'purple'"
                @click="selected.length == 0 ? null : printSeleted()"
                :class="selected.length == 0 ? 'ml-4 cursor-default' : 'ml-4 cursor-pointer'"
                v-bind="props"
              >
                mdi-printer</v-icon
              >
            </template>
            <span>Imprimir seleccionados</span>
          </v-tooltip>

          <v-tooltip bottom v-show="update_access">
            <template v-slot:activator="{ props }">
              <v-icon
                :color="selected.length == 0 ? 'grey' : 'orange'"
                @click="selected.length == 0 ? null : bloquearSeleted()"
                :class="selected.length == 0 ? 'ml-4 cursor-default' : 'ml-4 cursor-pointer'"
                v-bind="props"
              >
                mdi-sync</v-icon
              >
            </template>
            <span>Bloquear/Desbloquear seleccionados</span>
          </v-tooltip>
        </div>
        <v-data-table show-select :items-per-page="0" :headers="headers" :items="list" :search="search" :loading="loading" v-model="selected" hide-default-footer loading-text="Cargando...">
          <template v-slot:item="{ item, isSelected, toggleSelect }">
            <tr>
              <td class="pl-2">
                <v-checkbox style="margin: 0px; padding: 0px" hide-details :model-value="isSelected({ value: item.id })" @update:modelValue="toggleSelect({ value: item.id })" />
              </td>
              <td>
                {{ item.zona.almacen != null ? item.zona.almacen.code : "-" }}
              </td>
              <td>
                {{ item.zona != null ? item.zona.name : "-" }}
              </td>
              <td>
                {{ item.tipo_ubicacion.name }}
              </td>

              <td>{{ item.tipo_ubicacion.max_cant_pallets != null ? item.tipo_ubicacion.max_cant_pallets : "-" }}</td>

              <td>
                {{ item.code }}
              </td>
              <td>
                {{ item.rack }}
              </td>
              <td>
                {{ item.col }}
              </td>
              <td>
                {{ item.level }}
              </td>
              <td>
                <v-checkbox hide-details label="" :disabled="true" v-model="item.virtual"></v-checkbox>
              </td>
              <td>
                <v-checkbox hide-details label="" :disabled="true" v-model="item.multiple_lotes"></v-checkbox>
              </td>
              <td>
                {{ item.status.name }}
              </td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="purple" class="mr-2" v-on:click="print(item)" size="small"> mdi-printer</v-icon>
                  </template>
                  <span>Imprimir</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />

      <ModalPrint :show="dialog_print" @close="dialog_print = false" :selected="selected" :list="list" @cleanSelected="selected = []" />

      <ModalBloquear :show="dialog_bloquear" @close="dialog_bloquear = false" :selected="selected" :list="list" @cleanSelected="selected = []" @reloadList="filter" />

      <div class="text-right mt-2">
        <small class="text-grey">
          {{ paginationText }}
        </small>
      </div>
      <v-pagination
        v-if="cant_pages > 1"
        v-model="current_page"
        :length="cant_pages"
        total-visible="10"
        @update:modelValue="loadPage(service)"
      ></v-pagination>
    </v-container>
  </div>
</template>

<script>
import { ubicacionService } from "@/libs/ws/ubicacionService";
import { almacenService } from "@/libs/ws/almacenService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ModalPrint from "./ModalPrint.vue";
import ModalBloquear from "./ModalBloquear.vue";
import Modal from "./Modal.vue";
import { zonaService } from "@/libs/ws/zonaService";
import { tipoUbicacionService } from "@/libs/ws/tipoUbicacionService";
export default {
  components: { ModalPrint, ModalBloquear, Modal },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      service: ubicacionService,
      page_title: "Ubicaciones",
      modal_title: "Ubicacion",
      dialog_print: false,
      dialog_bloquear: false,
      selected: [],
      zonas: [],
      almacenes: [],
      tipos_ubicaciones: [],
      states: [],
      loading_zonas: false,
      loading_almacenes: false,
      loading_tipos_ubicaciones: false,
      filters: {
        zona: null,
        tipo_ubicacion: null,
        almacen: null,
        status: null,
        rack: null,
        col: null,
        level: null,
        code: null,
      },
      headers: [
        { title: "Almacen", key: "zona.almacen.code", sortable: false, class: "" },
        { title: "Zona", key: "zona.name", sortable: false, class: "" },

        { title: "Tipo", key: "tipo_ubicacion.name", sortable: false, class: "" },
        { title: "Max Pallet", key: "tipo_ubicacion.max_cant_pallets", sortable: false, class: "" },
        { title: "Codigo", key: "code", sortable: false, class: "bg-grey" },
        { title: "Rack", key: "rack", sortable: false, class: "bg-grey" },
        { title: "Columna", key: "col", sortable: false, class: "bg-grey" },
        { title: "Nivel", key: "level", sortable: false, class: "bg-grey" },
        { title: "Virtual", key: "virtual", sortable: false, class: "bg-blue" },
        { title: "Permitir mult. lotes", key: "multiple_lotes", sortable: false, class: "" },
        { title: "Estado", key: "status.name", sortable: false, class: "bg-grey" },
        { title: "Accion", key: "accion", sortable: false, class: "" },
      ],
    };
  },
  mounted() {
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    this.loadList(this.service);
    this.loadStates();
    this.loadAlmacenes();
    if (!this.filters.almacen?.sucursal) this.loadTiposUbicaciones();
  },
  watch: {
    "filters.almacen"(newVal, oldVal) {
      this.loadZonas();
      if (newVal?.sucursal?.id !== oldVal?.sucursal?.id) {
        this.filters.tipo_ubicacion = null;
        this.loadTiposUbicaciones();
      }
    },
  },
  methods: {
    loadStates() {
      ubicacionService
        .getStates()
        .then((response) => {
          this.states = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      this.loading_almacenes = true;
      almacenService
        .filter()
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_almacenes = false;
        });
    },
    loadZonas() {
      this.loading_zonas = true;
      zonaService
        .list_minify({ almacen: this.filters.almacen })
        .then((response) => {
          this.zonas = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_zonas = false;
        });
    },
    loadTiposUbicaciones() {
      this.loading_tipos_ubicaciones = true;
      tipoUbicacionService
        .filter({ sucursal: this.filters.almacen?.sucursal ?? null })
        .then((response) => {
          this.tipos_ubicaciones = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_tipos_ubicaciones = false;
        });
    },
    getFilterParams() {
      //Hay que sobreescribir si esta "zona" por "zona" = { "id": this.filters.zona.id, "name": this.filters.zona.name } y lo mismo con almacen
      if (this.filters.zona) {
        this.filters.zona = { id: this.filters.zona.id, name: this.filters.zona.name, label: this.filters.zona.label};
      }
      if (this.filters.almacen) {
        //Se conserva la sucursal porque los tipos de ubicacion se cargan por sucursal
        const sucursal = this.filters.almacen.sucursal ? { id: this.filters.almacen.sucursal.id } : null;
        this.filters.almacen = { id: this.filters.almacen.id, name: this.filters.almacen.name, label: this.filters.almacen.label, sucursal };
      }      
      this.filters.tipo_ubicacion = this.filters.tipo_ubicacion ? { id: this.filters.tipo_ubicacion.id, name: this.filters.tipo_ubicacion.name, label: this.filters.tipo_ubicacion.label } : null;
      this.filters.status = this.filters.status ? { id: this.filters.status.id, name: this.filters.status.name } : null;
      return this.filters;
    },
    filter() {
      this.current_page = 1;
      this.loadList(this.service);
    },
    printSeleted() {
      this.dialog_print = true;
    },
    print(item) {
      this.selected = [];
      this.selected.push(item.id);
      this.dialog_print = true;
    },
    bloquearSeleted() {
      this.dialog_bloquear = true;
    },
    bloquear() {
      //TODO: Bloquear ubicaciones
    },
  },
};
</script>
